import { blogList, blogPosts } from '../data/blogPosts';
import { publicationPreviewPath } from './adminNewsForm';
import { getCategoryMeta } from './newsPublications';

/** @typedef {{ slug: string, title: string, image: string, category: string, date: string, href: string }} FeaturedProductNews */

/**
 * @param {string | undefined | null} slug
 * @returns {FeaturedProductNews | null}
 */
export function resolveFeaturedNewsFromBlog(slug) {
  if (!slug) return null;
  const listItem = blogList.find((item) => item.slug === slug);
  const post = blogPosts[slug];
  if (!listItem && !post) return null;
  return {
    slug,
    title: post?.title || listItem?.title || '',
    image: post?.image || listItem?.image || '',
    category: post?.category || listItem?.category || 'Блог',
    date: post?.date || listItem?.date || '',
    href: `/blog/${slug}`,
  };
}

/**
 * @param {Record<string, unknown> | null | undefined} publication
 * @returns {FeaturedProductNews | null}
 */
export function mapPublicationToFeaturedNews(publication) {
  if (!publication?.slug) return null;
  const categoryMeta = getCategoryMeta(publication.category);
  return {
    slug: publication.slug,
    title: publication.title || '',
    image:
      publication.image ||
      publication.preview_image ||
      publication.previewImage ||
      publication.main_image ||
      publication.mainImage ||
      '',
    category: categoryMeta?.label || 'Новости',
    date:
      publication.display_date ||
      publication.displayDate ||
      publication.date ||
      '',
    href: publication.canonical_path || publication.canonicalPath || publicationPreviewPath(publication.slug),
  };
}

/**
 * @param {string | undefined | null} slug
 * @param {Record<string, unknown> | null | undefined} publication
 * @returns {FeaturedProductNews | null}
 */
export function resolveFeaturedProductNews(slug, publication) {
  if (!slug) return null;
  return resolveFeaturedNewsFromBlog(slug) || mapPublicationToFeaturedNews(publication);
}
